<div class="container-margin desktop-view">
  <div class="row">
    <span class="bold xx-large-font">Sustainability</span>
  </div>
  <div class="row margin-top-40">
    <span>Overall Sustainability Score</span>
  </div>
  <div class="row margin-top-10">
    <span class="xx-large-font">
      <span
        ><span class="bold">{{
          product.scores?.overallSustainabilityScore
        }}</span>
        / 100</span
      >
    </span>
  </div>
  <div class="margin-top-40">
    <mat-divider></mat-divider>
  </div>
  <div class="row margin-top-20">
    <span class="flex-basis-40">Condition</span>
    <span class="link-with-arrow">
      <span class="bold">{{ product.scores?.condition }}</span>
      <a [routerLink]="['']" class="dark-link-underline padding-left-10">
        Disassembly Instructions<mat-icon class="slant-arrow-icon"
          >call_made</mat-icon
        >
      </a>
    </span>
  </div>
  <div class="margin-top-20">
    <mat-divider></mat-divider>
  </div>
  <div class="row margin-top-20">
    <span class="flex-basis-40">Chemistry</span>
    <span class="bold"
      ><a class="dark-link-underline" [routerLink]="['']">View Details</a></span
    >
  </div>
  <div class="margin-top-20">
    <mat-divider></mat-divider>
  </div>
  <div class="row margin-top-20">
    <span class="flex-basis-40">Component Identifier</span>
    <span class="bold">{{ product.scores?.componentIdentifier }}</span>
  </div>
  <div class="margin-top-20">
    <mat-divider></mat-divider>
  </div>
  <div class="row margin-top-20">
    <span class="flex-basis-40">CFF Emissions</span>
    <span class="bold">{{ product.scores?.cffEmissions }}</span>
  </div>
  <div class="margin-top-20">
    <mat-divider></mat-divider>
  </div>
  <div class="row margin-top-20">
    <span class="flex-basis-40">Water Usage</span>
    <span class="bold">{{ product.scores?.waterUsage }}</span>
  </div>
  <div class="margin-top-20">
    <mat-divider></mat-divider>
  </div>
  <div class="row margin-top-20">
    <span class="flex-basis-40">Safe Use</span>
    <a class="dark-link-underline" [routerLink]="['']">
      <span class="vertical-center-flex">
        <span> Safe Use Instructions</span>
        <mat-icon class="slant-arrow-icon">call_made</mat-icon>
      </span>
    </a>
  </div>
  <div class="margin-top-20">
    <mat-divider></mat-divider>
  </div>
  <div class="row margin-top-20">
    <span class="flex-basis-40">Net Zero Score</span>
    <span
      ><span class="bold">{{ product.scores?.netZeroScore }}</span> / 100</span
    >
  </div>
  <div class="margin-top-20">
    <mat-divider></mat-divider>
  </div>
  <div class="row margin-top-20">
    <span class="flex-basis-40">Bio-Diversity Score</span>
    <span
      ><span class="bold">{{ product.scores?.bioDiversityScore }}</span> /
      100</span
    >
  </div>
  <div class="margin-top-20">
    <mat-divider></mat-divider>
  </div>
  <div class="row margin-top-20">
    <span class="flex-basis-40"
      >Modern Slavery (Forced and Child Labor) Score</span
    >
    <span
      ><span class="bold">{{ product.scores?.modernSlaveryScore }}</span> /
      100</span
    >
  </div>
  <div class="margin-top-20">
    <mat-divider></mat-divider>
  </div>
</div>

<div class="container mobile-view">
  <mat-toolbar class="row product-name-navbar">
    <span class="bold-600 medium-font">{{ product.name }}</span>
  </mat-toolbar>
  <div class="info-container-mobile">
    <div class="row margin-top-20">
      <span class="bold x-large-font">Sustainability</span>
    </div>
    <div class="row margin-top-20">
      <span>Overall Sustainability Score</span>
    </div>
    <div class="row margin-top-10">
      <span class="xx-large-font">
        <span
          ><span class="bold">{{
            product.scores?.overallSustainabilityScore
          }}</span>
          / 100</span
        >
      </span>
    </div>
    <div class="margin-top-20">
      <mat-divider></mat-divider>
    </div>
    <div class="row margin-top-10">
      <span>Condition</span>
    </div>
    <div class="row margin-top-5">
      <span class="link-with-arrow">
        <span>{{ product.scores?.condition }}</span>
        <a [routerLink]="['']" class="dark-link-underline padding-left-10"
          >Disassembly Instructions</a
        >
        <mat-icon class="slant-arrow-icon">call_made</mat-icon>
      </span>
    </div>
    <div class="margin-top-20">
      <mat-divider></mat-divider>
    </div>
    <div class="row margin-top-10">
      <span>Chemistry</span>
    </div>
    <div class="row margin-top-5">
      <span class="bold"
        ><a class="dark-link-underline" [routerLink]="['']"
          >View Details</a
        ></span
      >
    </div>
    <div class="margin-top-20">
      <mat-divider></mat-divider>
    </div>
    <div class="row margin-top-10">
      <span>Component Identifier</span>
    </div>
    <div class="row margin-top-5">
      <span class="bold">{{ product.scores?.componentIdentifier }}</span>
    </div>
    <div class="margin-top-20">
      <mat-divider></mat-divider>
    </div>
    <div class="row margin-top-10">
      <span>CFF Emissions</span>
    </div>
    <div class="row margin-top-5">
      <span class="bold">{{ product.scores?.cffEmissions }}</span>
    </div>
    <div class="margin-top-20">
      <mat-divider></mat-divider>
    </div>
    <div class="row margin-top-10">
      <span>Water Usage</span>
    </div>
    <div class="row margin-top-5">
      <span class="bold">{{ product.scores?.waterUsage }}</span>
    </div>
    <div class="margin-top-20">
      <mat-divider></mat-divider>
    </div>
    <div class="row margin-top-10">
      <span>Safe Use</span>
    </div>
    <div class="row margin-top-5">
      <span class="link-with-arrow">
        <a class="dark-link-underline" [routerLink]="['']"
          >Safe Use Instructions</a
        >
        <mat-icon class="slant-arrow-icon">call_made</mat-icon>
      </span>
    </div>
    <div class="margin-top-20">
      <mat-divider></mat-divider>
    </div>
    <div class="row margin-top-10">
      <span>Bio-Diversity Score</span>
    </div>
    <div class="row margin-top-5">
      <span
        ><span class="bold">{{ product.scores?.bioDiversityScore }}</span> /
        100</span
      >
    </div>
    <div class="margin-top-20">
      <mat-divider></mat-divider>
    </div>
    <div class="row margin-top-10">
      <span>Modern Slavery (Forced and Child Labor) Score</span>
    </div>
    <div class="row margin-top-5">
      <span
        ><span class="bold">{{ product.scores?.modernSlaveryScore }}</span> /
        100</span
      >
    </div>
  </div>
</div>
